import { useEffect, useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPostPaginationList } from "../../../../../redux/project/action";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import OrderPostPagination from "../../../FindWork/SearchAll/AllPosts/CustomPagination/OrderPostPagination";
import { PAGE_SIZE } from "../../../../../redux/constants";
import DeadlineComponents from "../../../../Common/DeadlineComponents";

export default function DeclinedProjects() {
  const path = "Assets/scss/myorders.module.scss";
  const { setManageAppliedprojectroute } = useRouteBaseStateContext();
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  // useEffect(() => {
  //   dispatch(getAppliedProjectList(1));
  // }, []);

  const [listdata, setListdata] = useState("")
  const [pageNumber, setPageNumber] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    const data = {
      type: 1,
      index: pageNumber,
      size: PAGE_SIZE,
      declined: 1
    }
    if (data) {
      dispatch(getPostPaginationList(data)).then((res) => {
        setListdata(res)
      })
    }

  }, [pageNumber]);

  return (
    <div className="order-tabs">
      <div className="tab-content">
        <div className="posted-project">
          {Array.isArray(listdata?.response) && (
            <>
              <h4>Project</h4>
              <OrderPostPagination
                totalitemcounts={listdata?.count?.declined_count}
                size={PAGE_SIZE}
                pageNumber={pageNumber}
                setPageNumber={setPageNumber}
              />
              {listdata?.response?.length == 0 && <PostNotFound title={"No Post Found"} />
              }
              <div className="recent-post">
                {listdata?.response.map((item, index) => (
                  <div className="post-back">
                    <div className="col-md-5 ">
                      <h3>{item?.title}</h3>
                      <div className="post-img">
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                            alt=""
                          />
                          <DeadlineComponents milestones={true} posts={item} />
                        </p>
                      </div>
                    </div>
                    <div className="activity col-md-4">
                      <h6>Activity</h6>
                      <div className="post-img">
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/post-proposal.svg`}
                            alt=""
                          />
                          Proposal: {item?.proposal_count}
                        </p>
                        {/* <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/myorders/message.svg`}
                            alt=""
                          />
                          Message: {item?.chat_count}
                        </p> */}
                      </div>
                    </div>
                    <button
                      className="btn"
                      onClick={() => {
                        navigate(
                          `/${lan}/dashboard/managework/projects/applied/${item.id}`,
                        );
                        setManageAppliedprojectroute("");
                      }}
                    >
                      View details
                      <img
                        src={`${CloudStorage.cloudurl}Assets/Images/homepage/right-arrow-orange.svg`}
                        alt=""
                      />
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
